import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import SaleEndCountdown from './SaleEndCountdown'
import StartTimeTab from './StartTimeTab'
import ProductScheduleButton from '@/components/shared/ProductScheduleButton'
import SaleProductList from './SaleProductList'
import { useRecentLiveStreamingProductList } from '../../../hooks/useRecentLiveStreamingProductList'
import { startOfDay, endOfDay, addDays } from 'date-fns'

// Libs
import useMedia from '@/hooks/useMedia'

// Constants

// Types

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const LiveDealsSection = () => {
  const { t } = useTranslation()
  const { isDesktop } = useMedia()

  const today = new Date()
  const todayStart = startOfDay(today)
  todayStart.setSeconds(50)

  const tomorrowEnd = endOfDay(addDays(today, 1))
  tomorrowEnd.setSeconds(50) // TODO: 沒 setSeconds 會是 15:59:59.000Z，但給這樣目前後端會給到隔日的 00:00:00.000Z，所以先給 15:59:50.000Z 以確保不會拿到隔天的，後端有空會再改

  const { timeList, groupProductData, selectedStartTime, setSelectedStartTime, targetTime, isFuture, roomInfo } = useRecentLiveStreamingProductList({
    pageNo: 1,
    pageSize: 300,
    startTime: new Date(todayStart),
    endTime: new Date(tomorrowEnd),
    enabledUndefinedCategoryId: true,
  })

  if (timeList.today.length === 0 && timeList.tomorrow.length === 0) return null

  return (
    <div className={cx('live-deals-section')}>
      <div className={cx('live-deals-section__header')}>
        <div className={cx('live-deals-section__header-top')}>
          <span className={cx('live-deals-section__header-title')}>{t('LiveDealsSection_Title')}</span>
          {!isDesktop && <ProductScheduleButton />}
        </div>
        {targetTime && (
          <SaleEndCountdown
            targetDate={new Date(targetTime)}
            isFuture={isFuture}
            roomId={roomInfo?.roomId || ''}
            liveSourceType={roomInfo?.liveSourceType || 0}
          />
        )}
        <StartTimeTab timeList={timeList} selectedStartTime={selectedStartTime} setSelectedStartTime={setSelectedStartTime} />
        {isDesktop && <ProductScheduleButton />}
      </div>
      <SaleProductList products={groupProductData[selectedStartTime] ?? []} />
    </div>
  )
}

export default LiveDealsSection
